import React from 'react'
import paymenterror from "../../assets/images/paymenterror.png"

const Cancel = () => {
  return (
    <div className="px-40 py-20">
    <div className="flex flex-col gap-10 items-center justify-center bg-gray-900 px-20 py-10 text-white">
      <img src={paymenterror} alt="Payment Error" className="w-20 mx-auto"/>
      <h1 className="text-2xl font-semibold">
        
        Payment Rejected
      </h1>
      <p>
        {" "}
        Oops! Your payment didn't go through. Please check your payment
            details and try again, or contact our support team for assistance.
      </p>
      <button
        type="button"
        className="px-3 py-2 me-2  text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-800 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
      >
        Back
      </button>
    </div>
  </div>
  )
}

export default Cancel